import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-dialog-footer-container',
	styleUrls: ['./dialog-footer-container.component.scss'],
	templateUrl: './dialog-footer-container.component.html',
	standalone: false,
})
export class DialogFooterContainerComponent {}
